<template>
    <!-- Begin Feature Area -->
    <div id="feature" class="feature-area feature-style-3">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="section-area">
                        <h2 id="more-info-section" class="section-title">Miksi valita meidät?</h2>
                        <p class="section-desc" style="min-width: 60vw;">Suha ei ainoastaan tee vastuullisuusraportoinnista nopeaa - se vie datasi suoraan asiakkaillesi, jotka sitä tarvitsevat. Yhdellä työkalulla täytät raportointivelvoitteen ja rakennat samalla kilpailuetua toimitusketjussa. Me mahdollistamme tämän mikro- ja pk-yrityksille logistiikka-alalla, veloituksetta.</p>
                    </div>
                    <!-- <div class="swiper-container feature-slider-2">
                        <div class="swiper-wrapper">
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="row feature-slider-2 mt-n30">
                <div v-for="(order, index) in paginatedOrders" :key="index" class="col-lg-6 mt-30">
                    <div class="feature-item" style="height: 33vh;">
                        <div class="feature-icon">
                            <img :src="order.featureImage" alt="Feature Icon">
                        </div>
                        <div class="feature-content">
                            <h3 class="title">{{order.title}}</h3>
                            <p class="desc">{{order.description}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="currentPage * maxPerPage < orders.length">
                <div class="col-12">
                    <div class="feature-btn-wrap">
                        <button class="btn btn-custom-size extbot-primary-3" @click="loadMore">Other Features</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Features Area End Here -->

</template>

<script>
export default {
  data () {
    return {
      orders: [
        {
          featureImage: 'images/feature/icon/2-1-47x47.png',
          title: 'Nopeus',
          description: 'VSME-raportin luominen voi kestää vain alle 5 minuuttia ja lähetämme sen suoraan sähköpostiisi'
        },
        {
          featureImage: 'images/feature/icon/2-2-47x47.png',
          title: 'Valinnanvapaus',
          description: 'Voit valita, täytätkö pelkästään raportointivelvoitteen vai haluatko mahdollisimman tarkan vastuullisuusarvion kehitysehdotuksineen'
        },
        {
          featureImage: 'images/feature/icon/2-3-47x47.png',
          title: 'Automaattinen tiedonjako',
          description: 'Sinun ei tarvitse enää toimittaa vastuulisuusdataa asiakkaillesi, me teemme sen puolestasi'
        },
        {
          featureImage: 'images/feature/icon/2-1-47x47.png',
          title: 'Räätälöinti',
          description: 'Logistiikka-alalle kehitetty järjestelmä mahdollistaa tehokkuuden parantamisen'
        },
      ],
      currentPage: 2,
      maxPerPage: 2,
      showReadMore: true
    }
  },
  computed: {
    totalResults () {
      return Object.keys(this.orders).length
    },
    pageCount () {
      return Math.ceil(this.totalResults / this.maxPerPage)
    },
    pageOffest () {
      return this.maxPerPage * this.currentPage
    },
    paginatedOrders () {
      return this.orders.slice(0, this.currentPage * this.maxPerPage)
    }
  },
  methods: {
    loadMore () {
      this.currentPage += 1
    }
  }
}
</script>

<style>
    html {
        scroll-behavior: smooth;
    }
</style>
